import { useState, useEffect, useRef } from "react";
import Calendar from "../components/Calendar";
import { Table } from "react-bootstrap";
import { Spinner } from "react-bootstrap";
import { fetchLowerHierarchicalOrgans } from "../http/resourcesServicesAPI";
import ShareButton from "../components/UI/ShareButton";

const LowerHierarchicalOrgans = () => {
	const [organs, setOrgans] = useState();
	const [loading, setLoading] = useState(true);

	const printRef = useRef(null);
	const handlePrint = () => {
		const originalBodyContent = document.body.innerHTML;
		document.body.innerHTML = printRef.current.outerHTML;
		window.print();

		onafterprint = (e) => {
			console.log(e);

			document.body.innerHTML = originalBodyContent;
		};
		window.location.reload();
	};

	useEffect(() => {
		fetchLowerHierarchicalOrgans()
			.then((data) => {
				setOrgans(data);
			})
			.finally(() => setLoading(false));
	}, []);
	if (loading) {
		return (
			<div className='d-flex align-items-center justify-content-center py-5'>
				<Spinner animation={"grow"} />
			</div>
		);
	}
	return (
		<div>
			<div className='d-flex flex-xl-row flex-column justify-content-center px-xl-4 px-2'>
				<div
					className='d-flex flex-column col-xl-8 px-xl-4'
					ref={printRef}>
					<div className='py-4 block-title text-center'>
						<span className='text-primary'>Organe Ierarhic Inferioare</span>
					</div>
					<Table
						bordered
						hover>
						<thead>
							<tr>
								<th
									style={{ verticalAlign: "middle" }}
									className='bg-primary text-white'>
									Denumire
								</th>
								<th
									style={{ verticalAlign: "middle" }}
									className='bg-primary text-white'>
									Adresa
								</th>
								<th
									style={{ verticalAlign: "middle" }}
									className='bg-primary text-white'>
									Telefon
								</th>
								<th
									style={{ verticalAlign: "middle" }}
									className='bg-primary text-white'>
									E-mail
								</th>
								<th
									style={{ verticalAlign: "middle" }}
									className='bg-primary text-white'>
									Program de lucru, Masa
								</th>
							</tr>
						</thead>
						<tbody>
							{organs.count > 0
								? organs.rows.map((item, idx) => (
										<tr key={idx}>
											<td style={{ verticalAlign: "middle" }}>{item.name}</td>
											<td style={{ verticalAlign: "middle" }}>{item.address}</td>
											<td style={{ verticalAlign: "middle" }}>{item.phone}</td>
											<td style={{ verticalAlign: "middle" }}>{item.email}</td>
											<td style={{ verticalAlign: "middle" }}>
												{item.schedule} {item.time}, {item.lunch}
											</td>
										</tr>
								  ))
								: null}
						</tbody>
					</Table>
					<div className='d-flex flex-xl-row flex-column align-items-center justify-content-end w-100'>
						<i
							role='button'
							onClick={() => handlePrint()}
							className='bi bi-printer text-primary icon-3 px-4'
							style={{
								fontWeight: "600 !important",
								WebkitTextStroke: 1,
							}}
						/>
						<ShareButton />
					</div>
				</div>
				<Calendar />
			</div>
		</div>
	);
};

export default LowerHierarchicalOrgans;
